
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import FigureItem  from "components/FigureItem";
import NuCheckbox from "components/nubox/NuCheckbox"
import { withRouterJim } from "router/withRouterJim";

import pdficon from "assets/img/pdficon.png";




import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";


const initialForm = {
  idd:0,
  ope:'n',
  
  id_doc:0,
  id_mate:0,
  id_peri:0,

  b1_cerrado_sn:0,
  b2_cerrado_sn:0,
  b3_cerrado_sn:0,
  b4_cerrado_sn:0,
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class Notasd extends React.Component {
  state = {

    modalImagen: false,
    
    fecha:'',
    
    form: Object.assign({}, initialForm),

    dataList: [],/* lista  */
    //{"col":1, "label":'A1', 'id_asisfe':145 }
    
  };
   //---------------- CONTEXT API ------------------
    //const store = useStore();
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({dataList:[]});
    
    //let bimestre = this.props.params.id;
    //this.cargar_data();
    this.cargar_form();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    //let id_asisfe = this.props.params.id;
    
    
  }
  //-------------------------
  imprimir =(bimestre)=>{
    let id_peri = this.props.store.user.id_peri
    let id_mate = this.props.store.materia.id_mate
    //notasd_pdf/{id_mate}/{id_peri}/{bimestre}
    let fileURL = process.env.REACT_APP_API_URL  + `notasd_pdf/${id_mate}/${id_peri}/${bimestre}`;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  //-------------------------
  imprimirCentral =()=>{
    let id_peri = this.props.store.user.id_peri
    let id_mate = this.props.store.materia.id_mate
    //notasd_pdf/{id_mate}/{id_peri}/{bimestre}
    let fileURL = process.env.REACT_APP_API_URL  + `tabla_notas_central_fin_pdf/${id_mate}/${id_peri}`;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  //-------------------------
  cargar_form = () => {
    //context API
    console.log("cargar_form");  
    let materia = this.props.store.materia
    let user = this.props.store.user

    let param = { 
      id_peri: user.id_peri,
      id_mate: materia.id_mate,
      id_doc: user.id_doc,
    }
    console.log(param); 
    axios2.post( "notasd_get_form", param )
    .then(res => {
      
        //if(! this.isEmptyObject(res.data)){ 
        
            this.setState({form: res.data}); 
            //añadimos el id y ope
            /*this.setState({
              form: {  ...this.state.form, 
                idd: idd,  
                ope: ope,
              },
            });*/
            //---------------
        

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  };
  //-------------------------------------
  //------------------------------
  render() {
    let materia = this.props.store.materia
    let user = this.props.store.user

    let form = this.state.form
    return(
      <div>
        {/* ---   --- */}
        { 
          //JSON.stringify(this.state.form)
        }
        <div className="escritorio center-align p-3">

          <div className="row">
            <div className="col-md-7">
              <h3> PLANILLA DE NOTAS { user.periodo } </h3>
              
              <p>
                Sigla: { materia.sigla }<br />
                Materia: { materia.nombre } /G { materia.grupo } <br />
                Periodo: { user.periodo } <br />
                { /* Fecha: { this.state.fecha }<br/> */}
              </p>
            </div>

            <div className="col-md-5">
              
            </div>

          </div>

          <div className="content">     
      
            
            <div className="table-responsive">
              <table align="center" className="table table-hover" width="100%">
                <thead>
                  <tr className="GridHeader" style={ { height:30 }}>
                    
                    <th align="center">BIMESTRE</th>
                    <th align="center">CERRADO</th>
                    <th align="center">LLENADO DE NOTAS</th>
                    <th align="center">PDF</th>
                  </tr>

                  <tr className="">
                    
                    <td>1</td>
                    
                    {this.state.form.b1_cerrado_sn===0?(
                      <>
                        <td><span className="label label-danger">NO</span></td>  
                        <td  style={{ textAlign: 'center' }}>
                          <Link to="/tabla_notas/1" className="btn btn-danger btn-sm" >Entrar</Link>
                        </td>
                        <td></td>
                      </>
                      ):(
                      <>
                        <td><span className="label label-success">SI</span></td>
                        <td></td>
                        <td style={{ textAlign: 'center' }}>
                          <Button onClick={()=> this.imprimir(1) } className="btn btn-default  ">
                          <img src ={pdficon} alt="Imprimir" width={32} /> Planilla de notas
                          </Button>
                        </td>
                      </>
                    )}
                  
                  </tr>
                  {/*----------------- */}
                  <tr className="">
                    
                    <td>2</td>
                    {this.state.form.b2_cerrado_sn===0?(
                      <>
                        <td><span className="label label-danger">NO</span></td>  
                        <td  style={{ textAlign: 'center' }}>
                          <Link to="/tabla_notas/2" className="btn btn-danger btn-sm" >Entrar</Link>
                        </td>
                        <td></td>
                      </>
                      ):(
                      <>
                        <td><span className="label label-success">SI</span></td>
                        <td></td>
                        <td style={{ textAlign: 'center' }}>
                          <Button onClick={()=> this.imprimir(2) } className="btn btn-default  ">
                          <img src ={pdficon} alt="Imprimir" width={32} /> Planilla de notas
                          </Button>
                        </td>
                      </>
                    )}
                    

                  </tr>
                  {/*----------------- */}
                  {/*----------------- */}
                  <tr className="">
                    
                    <td>3</td>
                    
                    {this.state.form.b3_cerrado_sn===0?(
                      <>
                        <td><span className="label label-danger">NO</span></td>  
                        <td  style={{ textAlign: 'center' }}>
                          <Link to="/tabla_notas/3" className="btn btn-danger btn-sm" >Entrar</Link>
                        </td>
                        <td></td>
                      </>
                      ):(
                      <>
                        <td><span className="label label-success">SI</span></td>
                        <td></td>
                        <td style={{ textAlign: 'center' }}>
                          <Button onClick={()=> this.imprimir(3) } className="btn btn-default  ">
                          <img src ={pdficon} alt="Imprimir" width={32} /> Planilla de notas
                          </Button>
                        </td>
                      </>
                    )}

                  </tr>
                  {/*----------------- */}
                  <tr className="">
                    
                    <td>4</td>
                    
                    {this.state.form.b4_cerrado_sn===0?(
                      <>
                        <td><span className="label label-danger">NO</span></td>  
                        <td  style={{ textAlign: 'center' }}>
                          <Link to="/tabla_notas/4" className="btn btn-danger btn-sm" >Entrar</Link>
                        </td>
                        <td></td>
                      </>
                      ):(
                      <>
                        <td><span className="label label-success">SI</span></td>
                        <td></td>
                        <td style={{ textAlign: 'center' }}>
                          <Button onClick={()=> this.imprimir(4) } className="btn btn-default  ">
                          <img src ={pdficon} alt="Imprimir" width={32} /> Planilla de notas
                          </Button>
                        </td>
                      </>
                    )}

                  </tr>

                </thead>
                <tbody>

                </tbody>
              </table>
            </div> 		

            <b>BOLETIN ANUAL</b>
            <div class="alert alert-secondary" role="alert">
              La planilla final solo se habilita, si esta cerrado las planillas de bimestres
            </div>

            <div className="table-responsive">
              <table align="center" className="table table-hover" width="100%">
                <thead>
                  <tr className="GridHeader" style={ { height:30 }}>
                    
                    <th align="center"></th>
                    <th align="center">CERRADO</th>
                    <th align="center">LLENADO DE NOTAS</th>
                    <th align="center">PDF</th>
                  </tr>

                  <tr className="">
                    
                    <td></td>
                    
                    
                    {this.state.form.final_cerrado==0?(
                      <>
                        <td>
                          <span className="label label-danger">NO</span>
                        </td>
                        <td  style={{ textAlign: 'center' }}>
                          { form.b1_cerrado_sn && form.b2_cerrado_sn && form.b3_cerrado_sn && form.b4_cerrado_sn? 
                          <Link to="/tabla_notas_central" className="btn btn-danger btn-sm" >Entrar</Link>
                          :
                            <span>Tiene que cerrar primero los bimestres</span>
                          }
                        </td>
                        <td></td>
                      </>
                    ): (
                      <>
                      <td>
                        <span className="label label-success">SI</span>
                      </td>
                      <td></td>
                      <td style={{ textAlign: 'center' }}>
                        
                        <Button onClick={()=> this.imprimirCentral() } className="btn btn-default  ">
                        <img src ={pdficon} alt="Imprimir" width={32} /> Planilla de notas
                        </Button>
                      </td>
                      </>
                      )
                    }
                    
                      
                    
                    

                  </tr>
                  {/*----------------- */}
       
                  {/*----------------- */}
               
            

                </thead>
                <tbody>

                </tbody>
              </table>
            </div> 					
          </div>


                          </div>


        <NotificationContainer/>
      </div>
    )
  }
  }
  
  //------------para que soporte la funcionalidad de parametros
  export default withRouterJim(Notasd);